import { root } from './data-export';

export const dataExport = {
  ...root,
};
